<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import router from "@/router";
import {fixedMenusToC, generateRoute, handleMenus} from "@/config/menusToC";

export default {
  name: 'App',
  created() {
    //初始化菜单 menu 以及对应路由
    const result = handleMenus(fixedMenusToC, [],'1' )
    this.$store.state.menus = result.menus;
    router.addRoutes(generateRoute(result.menus))
  },
}
</script>

<style>
/* 你可以保留或移动这里的全局样式 */
</style>
